import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollNaarAnker } from '../utils/scrollNaarAnker';

// Bij een nieuwe pagina naar boven, behalve als de URL een #anker heeft: dan
// naar dat anker. Ook bij het eerste laden, dus een link naar een kop werkt.
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return scrollNaarAnker(hash);
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
